import { render, staticRenderFns } from "./OptometryHall.vue?vue&type=template&id=b49d2668&scoped=true&"
import script from "./OptometryHall.vue?vue&type=script&lang=js&"
export * from "./OptometryHall.vue?vue&type=script&lang=js&"
import style0 from "./OptometryHall.vue?vue&type=style&index=0&id=b49d2668&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49d2668",
  null
  
)

export default component.exports